/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockOutboundDetailExportDto } from './StockOutboundDetailExportDto';
import {
    StockOutboundDetailExportDtoFromJSON,
    StockOutboundDetailExportDtoFromJSONTyped,
    StockOutboundDetailExportDtoToJSON,
    StockOutboundDetailExportDtoToJSONTyped,
} from './StockOutboundDetailExportDto';

/**
 * 
 * @export
 * @interface ResponseListStockOutboundDetailExportDto
 */
export interface ResponseListStockOutboundDetailExportDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockOutboundDetailExportDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockOutboundDetailExportDto
     */
    message?: string;
    /**
     * 
     * @type {Array<StockOutboundDetailExportDto>}
     * @memberof ResponseListStockOutboundDetailExportDto
     */
    data?: Array<StockOutboundDetailExportDto>;
}

/**
 * Check if a given object implements the ResponseListStockOutboundDetailExportDto interface.
 */
export function instanceOfResponseListStockOutboundDetailExportDto(value: object): value is ResponseListStockOutboundDetailExportDto {
    return true;
}

export function ResponseListStockOutboundDetailExportDtoFromJSON(json: any): ResponseListStockOutboundDetailExportDto {
    return ResponseListStockOutboundDetailExportDtoFromJSONTyped(json, false);
}

export function ResponseListStockOutboundDetailExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockOutboundDetailExportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockOutboundDetailExportDtoFromJSON)),
    };
}

export function ResponseListStockOutboundDetailExportDtoToJSON(json: any): ResponseListStockOutboundDetailExportDto {
    return ResponseListStockOutboundDetailExportDtoToJSONTyped(json, false);
}

export function ResponseListStockOutboundDetailExportDtoToJSONTyped(value?: ResponseListStockOutboundDetailExportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockOutboundDetailExportDtoToJSON)),
    };
}

